import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class TranslationListService {
    constructor(private datatask: DataTaskService) {}

    public async getTranslationsPage(): Promise<TranslationsGet> {
        return (await this.datatask.Post(1127))[0];
    }

    public getLanguages(addDetect?: '0' | '1'): Promise<TranslationLanguage[]> {
        return this.datatask.Post(57, addDetect === undefined ? {} : { add_detect: addDetect });
    }

    public getTranslations(params: TranslationsGet): Promise<TranslationItem[]> {
        return this.datatask.Post(60, params);
    }

    public getSearchTranslations(params: TranslationsGet): Promise<TranslationItem[]> {
        return this.datatask.Post(2966, params);
    }

    public async getTranslationEdit(wordId: string): Promise<TranslationEditGet> {
        return (await this.datatask.Post(2928, { word_id: wordId }))[0];
    }

    public getTranslationEdits(wordId: string): Promise<TranslationEditItem[]> {
        return this.datatask.Post(61, { word_id: wordId });
    }

    public saveTranslationEdits(edits: TranslationEditItem[]): Promise<void> {
        return this.datatask.Post(62, { wordlang_names: edits });
    }
}

export interface TranslationsGet {
    language_id_to_translate: string;
    language_id_display: string;
    bg_translate_type: TranslationType;
    word_last_used_dt: string;
    searchtext: string;
}

export type TranslationType = 'SEARCH' | 'NOTTRANSLATED' | 'TRANSLATED';

export interface TranslationLanguage extends Item {
    google_language_id: string;
}

export interface TranslationItem extends Item {}

export interface TranslationEditGet {
    translateedit_text_to_translate: string;
    translateedit_translate_from_language: string;
}

export interface TranslationEditItem {
    word_id: string;
    language_id: string;
    language_name: string;
    google_language_id: string;
    wordlang_name: string;
    translated_name?: string;
    keeptext: string;
}
